import { defineComponent } from 'vue';

import Modal from '~/components/modals/modal.vue';
import ComponentBase from '../component-base';

export default defineComponent({

    extends: ComponentBase,

    components: {
        Modal,
    },

    mounted() {
        if(!this.$refs.modal) {
            throw Error('component should have modal ref')
        }
    },

    methods: {
        open() {
            this.$refs.modal.open();
        },

        close(result:boolean = false) {
            this.$refs.modal.close(result);
        }

    }

})